// Login.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('email') !== null && localStorage.getItem('password') !== null) {
      navigate('/home');
    }
  });

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const EmailChange = (e) => {
    setEmail(e.target.value);
  };

  const PasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const hashPassword = (plainPassword) => {
    return CryptoJS.SHA256(plainPassword).toString(CryptoJS.enc.Hex);
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  const handleLogin = async () => {
    try {
      if (email === '' || password === '') throw new Error('Please fill the form');
      const hashedPassword = hashPassword(password);

      const response = await axios.post('https://pgdost.onrender.com/api/login', {
        email: email,
        password: hashedPassword,
      });

      if (response.data.success) {
        localStorage.setItem('email', email);
        localStorage.setItem('password', hashedPassword);

        toast.success('Successfully logged in. Redirecting you to the dashboard.');
        setTimeout(() => (window.location.href = '/home'), 2000);
      }
    } catch (error) {
      toast.error('Check Username And Password', error.message);
    }
  };

  return (
    <div className="container mx-auto mt-20 flex justify-center">
      <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-96">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
            Email address
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="email"
            type="email"
            placeholder="Email"
            onChange={EmailChange}
            value={email}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
            Password
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="password"
            type="password"
            placeholder="Password"
            onChange={PasswordChange}
            value={password}
          />
        </div>
        <div className="mb-6">
          <button
            className="w-full bg-green-500 text-white py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
        <p className="text-center text-sm p-4">
          <span className="text-blue-500 cursor-pointer" onClick={handleForgotPassword}>
            Forgot Password?
          </span>
        </p>
        <p className="text-center text-sm">
          <span className="text-blue-500 cursor-pointer" onClick={handleSignup}>
            New to PGDost? Sign up Now!
          </span>
        </p>
      </form>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};
